import { render } from "./CustomerCheck.vue?vue&type=template&id=deac7e6a&scoped=true&ts=true"
import script from "./CustomerCheck.vue?vue&type=script&lang=ts"
export * from "./CustomerCheck.vue?vue&type=script&lang=ts"

import "./CustomerCheck.vue?vue&type=style&index=0&id=deac7e6a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deac7e6a"]])

export default __exports__